<div class="flex flex-col" *transloco="let t">
	@if (!config.hideBackButton) {
		<vis-ods-icon-button-component
			name="backArrow"
			class="pb-m"
			(click)="backToMainMenu()"
		></vis-ods-icon-button-component>
	}

	<div class="flex flex-col">
		<div class="flex flex-row bg-light-01 py-m px-2xs mb-l">
			<vis-ods-icon-component
				name="search"
				class="flex w-[15px] h-[15px] mt-[13px]"
			></vis-ods-icon-component>
			<input
				type="text"
				autocomplete="off"
				class="text-body text-body-m bg-transparent border-0 w-full focus:ring-transparent border-b border-inactive focus:border-inactive"
				placeholder="{{ t('generalComponents.storeSelector.texts.placeholder') }}"
				(input)="searchTermChanged($any($event.target).value)"
			/>
		</div>
		<div class="flex flex-col">
			<ng-container *ngIf="!storesLoading; appLoadingAnimation">
				@for (store of $filteredStores(); track store.customerNumber) {
					<label
						[attr.data-testid]="'selectable-store'"
						class="flex items-start py-m cursor-pointer border-inactive border-b"
						(click)="onStoreChange(store)"
					>
						<input type="radio" class="mt-2xs cursor-pointer" [checked]="isSelected(store)" />
						<div class="ml-m flex flex-col">
							<beyond-online-headline
								size="xs"
								[headline]="store.firstLineName + ' (' + store.customerNumber + ')'"
							></beyond-online-headline>
							<span beyond-online-text>{{ store.street }}, {{ store.city }}</span>
						</div>
					</label>
				}

				@if (!config.hideFooter && stores) {
					<div
						class="flex flex-col text-body-s text-body py-m cursor-pointer border-inactive border-b"
					>
						{{ t('generalComponents.storeSelector.texts.footer') }}
					</div>
				}
			</ng-container>
		</div>
	</div>
</div>
